import React from "react";
import "../DashboardUnique.css";

export default function VillageWiseMandalHeader({ village, handleNavigateToMainTab, selectedBhajanMandaliType, villageCount, theme }) {
  console.log("checkingthevalueOfTheme", theme);
  return (
    <div className={`govdash-villageDetailHeader`}>
      <div onClick={handleNavigateToMainTab} className={"govdash-detailIconWrapper cursor-pointer"}>
        <i className="govdash-VillageHeaderCard-icon  fas fa-house-user"></i>
      </div>
      <div className={"govdash-detailInfo"}>
        <h2 className={"govdash-detailName"}>{selectedBhajanMandaliType?.bhajanMandaliType}</h2>
        <div className={"govdash-detailStats"}>
          <div className={"govdash-statItem "}>
            {/* <span className={"govdash-statLabel"}>Mandali Count</span> */}
            <span className={"govdash-statLabel"}>Member Count</span>
            <span className={"govdash-statValue"}>{selectedBhajanMandaliType?.totalMemberCount}</span>
          </div>
          <div className={"govdash-statItem "}>
            <span className={"govdash-statLabel"}>Village Count</span>
            <span className={"govdash-statValue"}>{villageCount}</span>
          </div>
          <div className={"govdash-statItem "}>
            <span className={"govdash-statLabel"}>Mandali Count</span>
            <span className={"govdash-statValue"}>{selectedBhajanMandaliType?.totalMandaliCount}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
